import { render, staticRenderFns } from "./ConfirmAttendance.vue?vue&type=template&id=1f37c963"
import script from "./ConfirmAttendance.vue?vue&type=script&lang=js"
export * from "./ConfirmAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports